import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Typography, Grid } from '@mui/material'
import { useIntl } from 'react-intl'

import { TextInput, ThemeButton, AutocompleteInput } from '../../../../ui'
import { EDIT_FORM_CONFIG } from './edit-user-constants'

export const EditManager = ({ close, editManager, props }) => {
  const intl = useIntl()
  const combos = useSelector((state) => state.combos)
  const managers = useSelector((state) => state.managers.data)
  const manager = props.rowData
  const dispatch = useDispatch()
  const [formState, setFormState] = useState(manager)

  const handleChangeForm = (e) => {
    const name = e?.target?.name || e?.name

    let value =
      e?.target !== undefined
        ? e.target.value
        : Array.isArray(e?.value)
          ? e.value.map((v) => v.key || v)
          : e?.value
    if (name === 'cc_aa' && Array.isArray(value)) {
      value = value.map((v) => parseInt(v, 10))
    }
    setFormState((prev) => ({ ...prev, [name]: value }))
  }

  const handleEditUser = (e) => {
    e.preventDefault()
    if (JSON.stringify(manager) !== JSON.stringify(formState)) {
      dispatch(editManager(props.rowData, formState, managers))
    }
    close()
  }
  const selectedRole = combos.roles?.data?.find((r) => r.key === formState.rol)
  const isOrganismoIP = selectedRole?.value?.toLowerCase().includes('organismo ip')
  const inputProps = { formState, combos, intl, onChange: handleChangeForm }
  return (
    <Box p={4}>
      <Box mb={3}>
        <Typography variant="h3" color="primary">
          {intl.formatMessage({ id: 'pages.managers.dialogs.edit.title' })}
        </Typography>
      </Box>
      <form onSubmit={handleEditUser}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 6, sm: 4, md: 3 }}>
            <TextInput {...EDIT_FORM_CONFIG(inputProps).NOMBRE} />
          </Grid>

          <Grid size={{ xs: 6, sm: 4, md: 3 }}>
            <TextInput {...EDIT_FORM_CONFIG(inputProps).APELLIDOS} />
          </Grid>
          <Grid size={{ xs: 6, sm: 4, md: 3 }}>
            <TextInput {...EDIT_FORM_CONFIG(inputProps).USERNAME} />
          </Grid>

          <Grid size={{ xs: 6, sm: 4, md: 3 }}>
            <TextInput {...EDIT_FORM_CONFIG(inputProps).ROL} />
          </Grid>
          <Grid size={{ xs: 6, sm: 4, md: 3 }}>
            <TextInput {...EDIT_FORM_CONFIG(inputProps).TELEFONO} />
          </Grid>
          <Grid size={{ xs: 6, sm: 4, md: 3 }}>
            <TextInput {...EDIT_FORM_CONFIG(inputProps).CORREO_ELECTRONICO} />
          </Grid>
          {isOrganismoIP && (
            <Grid size={{ xs: 6, sm: 4, md: 3 }}>
              <AutocompleteInput {...EDIT_FORM_CONFIG(inputProps).CCAA} />
            </Grid>
          )}
        </Grid>
        <Box mt={8} display="flex" justifyContent="space-between">
          <ThemeButton onClick={close} variant="outlined" labelM="lg">
            {intl.formatMessage({ id: 'global.cancel' })}
          </ThemeButton>
          <ThemeButton color="primary" type="submit" labelM="lg">
            {intl.formatMessage({ id: 'global.accept' })}
          </ThemeButton>
        </Box>
      </form>
    </Box>
  )
}
